const formattedTime = time => {
  const t = new Date(time);
  return [t.getHours(), t.getMinutes()]
    .map(n => (n < 10 ? `0${n}` : `${n}`))
    .join(':');
};

export default formattedTime;
